export default "__VITE_ASSET__r55qFnvW__"